export enum AuditLogUserActivationReasonType {
    ManualVerificationDone = 1,
}

export const AuditLogUserActivationReasonTypeMapping = [
    { text: 'Manual Verification Done', value: AuditLogUserActivationReasonType.ManualVerificationDone },
  ];
